import angular from 'angular';

module.exports = angular.module('common.filters.join', [])
.filter('join', function() {
  return function(input, delimeter) {
    delimeter = delimeter || ', ';

    if (Array.isArray(input)) {
      return input.join(delimeter);
    } else {
      return input;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/join.js
 **/